// Misc
import * as PicoX from "@/bsp-integration/app-tracking-logic/pico/pico";
import { Configs } from "@/configs";
import { default as Logger } from "@/modules/logs";
import * as Utils from "@/utils";

// Third party integrations
import * as Impact from "@/vendors/impact";

const Misc = {
  Configs,
  Logger,
  Utils,
  Impact,
  PicoX,
};

window.MiQ = { ...(window.MiQ || {}), ...Misc };

export { Configs, Impact, Logger, PicoX, Utils };

// Modules
export { default as Experiments } from "@/modules/experiments";
export { default as Flags } from "@/modules/flags";
export { default as Telemetry } from "@/modules/telemetry";
